<template>
    <div class="invite-owner">
        <div class="page-header">
			<h1>Invite Owner</h1>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
				<el-breadcrumb-item>Agency</el-breadcrumb-item>
				<el-breadcrumb-item>Invite Owner</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
        <work-in-progress />
    </div>
</template>

<script>
export default {
    name: 'InviteOwner'
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';

</style>



// WEBPACK FOOTER //
// src/views/agency/InviteOwner.vue